import axios from "axios";
import {
  url,
  dispatchLoading,
  dispatchToast,
  dispatchError,
  catchHandler,
  elseHandler,
} from "../utils";
import { FetchBookingList } from "../Customer/redux/Booking";
import { DashboardData } from "../Admin/Redux/Dashboard";

const carUrl = url + "car";
const itemPerPage = 12;

export const HomePageCarList = () => async (dispatch) => {
  dispatchLoading(dispatch, "car", true);
  axios
    .get(carUrl + "/homePage", { withCredentials: true })
    .then((result) => {
      if (result?.data?.success) {
        dispatch({ type: "CAR_HOME_SUCCESS", payload: result?.data?.data });
        dispatchError(dispatch, "car", undefined);
      } else elseHandler(dispatch, "car", result?.data);
      dispatchLoading(dispatch, "car", false);
    })
    .catch(catchHandler(dispatch, "car"));
};
export const ListCar =
  (
    pageId = 0,
    type = [],
    transmissionType = false,
    totalSeat = 0,
    luggageBox = 0,
    minAgeDrive = 0,
    priority = undefined
  ) =>
  async (dispatch) => {
    dispatchLoading(dispatch, "car", true);
    let params = { itemPerPage, pageId, isActive: true, isDeleted: false };
    if (type.length > 0) params["type"] = type;
    if (transmissionType === true) params["transmissionType"] = "A";
    if (totalSeat !== 0) params["totalSeat"] = totalSeat;
    if (minAgeDrive !== 0) params["minAgeDrive"] = minAgeDrive;
    if (luggageBox !== 0) params["luggageBox"] = luggageBox;
    if (priority !== undefined) params["priority"] = priority;
    axios
      .get(carUrl + "/list", { params: params, withCredentials: true })
      .then((result) => {
        if (result?.data?.success) {
          dispatch({ type: "CAR_LIST_SUCCESS", payload: result?.data?.data });
          dispatchError(dispatch, "car", undefined);
        } else elseHandler(dispatch, "car", result?.data);
        dispatchLoading(dispatch, "car", false);
      })
      .catch(catchHandler(dispatch, "car"));
  };

export const AdminListCar =
  (pageId, carType, isDeleted) => async (dispatch) => {
    dispatchLoading(dispatch, "car", true);
    axios
      .get(carUrl + "/list/admin", {
        params: { pageId, itemPerPage, carType, isDeleted },
        withCredentials: true,
      })
      .then((result) => {
        if (result?.data?.success) {
          dispatch({ type: "CAR_LIST_SUCCESS", payload: result?.data?.data });
          dispatchError(dispatch, "car", undefined);
        } else elseHandler(dispatch, "car", result?.data);
        dispatchLoading(dispatch, "car", false);
      })
      .catch(catchHandler(dispatch, "car"));
  };
export const GetCar = (carId) => async (dispatch) => {
  dispatchLoading(dispatch, "car", true);
  let noDiskCache = { noDiskCache: 1, timeStamp: `${new Date().getTime()}` };
  axios
    .get(carUrl + "/detail", {
      params: { carId, noDiskCache },
      withCredentials: true,
    })
    .then((result) => {
      if (result?.data?.success) {
        dispatch({
          type: "CAR_SET",
          payload: { name: "detail", value: result?.data?.data },
        });
        dispatchError(dispatch, "car", undefined);
      } else elseHandler(dispatch, "car", result?.data);
      dispatchLoading(dispatch, "car", false);
    })
    .catch(catchHandler(dispatch, "car"));
};

export const AddCar = (data, navigate) => async (dispatch) => {
  dispatchLoading(dispatch, "car", true);
  axios
    .post(carUrl, data, { withCredentials: true })
    .then((result) => {
      if (result?.data?.success) {
        dispatch({
          type: "CAR_SET",
          payload: { name: "recentCarId", value: result?.data?.data?._id },
        });
        navigate("/admin/cars");
        dispatchToast(dispatch, "success", result?.data?.msg);
        dispatchError(dispatch, "car", undefined);
        dispatch(DashboardData());
      } else elseHandler(dispatch, "car", result?.data);
      dispatchLoading(dispatch, "car", false);
    })
    .catch(catchHandler(dispatch, "car"));
};

export const UpdateCar =
  (
    carId,
    updates,
    setIsModalOpen,
    setModalPurpose,
    pageId,
    carType,
    navigate
  ) =>
  async (dispatch) => {
    dispatchLoading(dispatch, "car", true);
    axios
      .put(carUrl + "/", { carId, updates }, { withCredentials: true })
      .then((result) => {
        if (result?.data?.success) {
          dispatch({
            type: "CAR_SET",
            payload: { name: "recentCarId", value: result?.data?.data?.carId },
          });
          navigate(`/admin/cars/detail/${carId}`);
          dispatchToast(dispatch, "success", result?.data?.msg);
          dispatchError(dispatch, "car", undefined);
          setIsModalOpen(false);
          setModalPurpose(-1);
          dispatch(AdminListCar(pageId, carType));
        } else elseHandler(dispatch, "car", result?.data);
        dispatchLoading(dispatch, "car", false);
      })
      .catch(catchHandler(dispatch, "car"));
  };

export const DeleteCar = (carId, pageId, carType) => async (dispatch) => {
  dispatchLoading(dispatch, "car", true);
  axios
    .delete(carUrl + "/", { data: { carId }, withCredentials: true })
    .then((result) => {
      if (result?.data?.success) {
        dispatch(AdminListCar(pageId, carType));
        dispatch(DashboardData());
        dispatchToast(dispatch, "success", result?.data?.msg);
        dispatchError(dispatch, "car", undefined);
      } else elseHandler(dispatch, "car", result?.data);
      dispatchLoading(dispatch, "car", false);
    })
    .catch(catchHandler(dispatch, "car"));
};

export const RestoreCar =
  (carId, pageId, carType, setModal) => async (dispatch) => {
    dispatchLoading(dispatch, "car", true);
    axios
      .put(carUrl + "/restore", { carId }, { withCredentials: true })
      .then((result) => {
        if (result?.data?.success) {
          setModal(false);
          dispatch(AdminListCar(pageId, carType, true));
          dispatch(DashboardData());
          dispatchToast(dispatch, "success", result?.data?.msg);
          dispatchError(dispatch, "car", undefined);
        } else elseHandler(dispatch, "car", result?.data);
        dispatchLoading(dispatch, "car", false);
      })
      .catch(catchHandler(dispatch, "car"));
  };

export const SearchCar = (search) => async (dispatch) => {
  dispatchLoading(dispatch, "car", true);
  axios
    .get(carUrl + "/search", {
      params: { search, isDeleted: false },
      withCredentials: true,
    })
    .then((result) => {
      if (result?.data?.success) {
        dispatch({ type: "CAR_SEARCH_SUCCESS", payload: result?.data?.data });
        dispatchError(dispatch, "car", undefined);
      } else elseHandler(dispatch, "car", result?.data);
      dispatchLoading(dispatch, "car", false);
    })
    .catch(catchHandler(dispatch, "car"));
};

export const toggleCarActive = (carId, isActive) => async (dispatch) => {
  dispatchLoading(dispatch, "car", true);
  axios
    .put(
      carUrl + "/",
      {
        carId,
        updates: {
          isActive,
        },
      },
      { withCredentials: true }
    )
    .then((result) => {
      if (result?.data?.success) {
        dispatch({
          type: "CAR_TOGGLEACTIVE_SUCCESS",
          payload: result?.data?.data,
        });
        dispatchToast(dispatch, "success", result?.data?.msg);
        dispatchError(dispatch, "car", undefined);
      } else elseHandler(dispatch, "car", result?.data);
      dispatchLoading(dispatch, "car", false);
    })
    .catch(catchHandler(dispatch, "car"));
};
export const toggleCarApproval =
  (carId, requireApproval) => async (dispatch) => {
    dispatchLoading(dispatch, "car", true);
    axios
      .put(
        carUrl + "/",
        {
          carId,
          updates: {
            requireApproval,
          },
        },
        { withCredentials: true }
      )
      .then((result) => {
        if (result?.data?.success) {
          dispatch({
            type: "CAR_APPROVAL_SUCCESS",
            payload: result?.data?.data,
          });
          dispatchToast(dispatch, "success", result?.data?.msg);
          dispatchError(dispatch, "car", undefined);
        } else elseHandler(dispatch, "car", result?.data);
        dispatchLoading(dispatch, "car", false);
      })
      .catch(catchHandler(dispatch, "car"));
  };
export const toggleCarPremium = (carId, premiumCar) => async (dispatch) => {
  dispatchLoading(dispatch, "car", true);
  axios
    .put(
      carUrl + "/",
      {
        carId,
        updates: {
          premiumCar,
        },
      },
      { withCredentials: true }
    )
    .then((result) => {
      if (result?.data?.success) {
        dispatch({ type: "CAR_PREMIUM_SUCCESS", payload: result?.data?.data });
        dispatchToast(dispatch, "success", result?.data?.msg);
        dispatchError(dispatch, "car", undefined);
      } else elseHandler(dispatch, "car", result?.data);
      dispatchLoading(dispatch, "car", false);
    })
    .catch(catchHandler(dispatch, "car"));
};

export const GetCarMeta = (type, name) => async (dispatch) => {
  dispatchLoading(dispatch, "car", true);
  let noDiskCache = { noDiskCache: 1, timeStamp: `${new Date().getTime()}` };
  axios
    .get(carUrl + "/" + type, { params: noDiskCache, withCredentials: true })
    .then((result) => {
      if (result?.data?.success) {
        dispatch({
          type: "CAR_SET",
          payload: { name, value: result?.data?.data },
        });
        dispatchError(dispatch, "car", undefined);
      } else elseHandler(dispatch, "car", result?.data);
      dispatchLoading(dispatch, "car", false);
    })
    .catch(catchHandler(dispatch, "car"));
};

export const GetCarTypeMeta =
  (type, name, noCache, setIsModalOpen) => async (dispatch) => {
    dispatchLoading(dispatch, "car", true);
    let tempApiUrl = noCache
      ? `${carUrl}/${type}?withImg=1&noCache=1`
      : `${carUrl}/${type}?withImg=1`;
    let noDiskCache = { noDiskCache: 1, timeStamp: `${new Date().getTime()}` };
    axios
      .get(tempApiUrl, { params: noDiskCache, withCredentials: true })
      // .get(carUrl + "/" + type, { query: query, withCredentials: true })
      .then((result) => {
        if (result?.data?.success) {
          dispatch({
            type: "CAR_SET",
            payload: { name, value: result?.data?.data },
          });
          setIsModalOpen(false);
          dispatchError(dispatch, "car", undefined);
        } else elseHandler(dispatch, "car", result?.data);
        dispatchLoading(dispatch, "car", false);
      })
      .catch(catchHandler(dispatch, "car"));
  };

export const DeleteCarTypeImageMeta = (name, typeId) => async (dispatch) => {
  dispatchLoading(dispatch, "car", true);
  axios
    .delete(`${carUrl}/upload/type`, {
      data: { typeId },
      withCredentials: true,
    })
    .then((result) => {
      if (result?.data?.success) {
        // dispatch({ type: "CAR_SET", payload: { name, value: result?.data?.data } });
        dispatchError(dispatch, "car", undefined);
      } else elseHandler(dispatch, "car", result?.data);
      dispatchLoading(dispatch, "car", false);
    })
    .catch(catchHandler(dispatch, "car"));
};

const CarMetaSuccessHandler = (dispatch, url, setIsModalOpen) => (result) => {
  if (result?.data?.success) {
    setIsModalOpen(false);
    dispatch(GetCarMeta(url, `${url}List`));
    dispatchToast(dispatch, "success", result?.data?.msg);
    dispatchError(dispatch, "car", undefined);
  } else elseHandler(dispatch, "car", result?.data);
  dispatchLoading(dispatch, "car", false);
};

export const AddCarMeta =
  (url, name, value, setIsModalOpen) => async (dispatch) => {
    dispatchLoading(dispatch, "car", true);
    let query = {};
    query[name] = value;
    axios
      .post(carUrl + "/" + url, query, { withCredentials: true })
      .then((result) => {
        if (name == "type") {
          dispatch(GetCarTypeMeta("type", "typeList", true, setIsModalOpen));
          dispatchToast(dispatch, "success", result?.data?.msg);
        } else {
          // dispatch(CarMetaSuccessHandler(dispatch, url));
          if (result?.data?.success) {
            dispatch(GetCarMeta(url, `${url}List`));
            dispatchToast(dispatch, "success", result?.data?.msg);
            dispatchError(dispatch, "car", undefined);
            setIsModalOpen(false);
          } else {
            elseHandler(dispatch, "car", result?.data);
          }
          dispatchLoading(dispatch, "car", false);
        }
      })
      .catch(catchHandler(dispatch, "car"));
  };
export const RemoveCarMeta =
  (url, name, value, setIsModalOpen) => async (dispatch) => {
    dispatchLoading(dispatch, "car", true);
    let query = {};
    query[name] = value;
    axios
      .delete(carUrl + "/" + url, { data: query, withCredentials: true })
      .then(CarMetaSuccessHandler(dispatch, url, setIsModalOpen))
      .catch(catchHandler(dispatch, "car"));
  };

export const AddCarColor = (name, hex, setIsModalOpen) => async (dispatch) => {
  dispatchLoading(dispatch, "car", true);
  axios
    .post(carUrl + "/color", { name, hex }, { withCredentials: true })
    .then((result) => {
      if (result?.data?.success) {
        dispatch(GetCarMeta("color", "colorList"));
        dispatchToast(dispatch, "success", result?.data?.msg);
        setIsModalOpen(false);
        dispatchError(dispatch, "car", undefined);
      } else elseHandler(dispatch, "car", result?.data);
      dispatchLoading(dispatch, "car", false);
    })
    .catch(catchHandler(dispatch, "car"));
};

export const AddCarReview = (data, setIsWriteModel) => async (dispatch) => {
  dispatchLoading(dispatch, "car", true);
  axios
    .post(carUrl + "/review", data, { withCredentials: true })
    .then((result) => {
      if (result?.data?.success) {
        dispatchToast(dispatch, "success", "Review Added Successfully");
        dispatchError(dispatch, "car", undefined);
        dispatch(FetchBookingList());
        setIsWriteModel(false);
      } else elseHandler(dispatch, "car", result?.data);
      dispatchLoading(dispatch, "car", false);
    })
    .catch(catchHandler(dispatch, "car"));
};

export const DeleteCarPhoto = (photoId) => async (dispatch) => {
  dispatchLoading(dispatch, "car", true);
  axios
    .delete(carUrl + "/upload", { data: { photoId }, withCredentials: true })
    .then((result) => {
      if (result?.data?.success) {
        dispatchError(dispatch, "car", undefined);
      } else elseHandler(dispatch, "car", result?.data);
      dispatchLoading(dispatch, "car", false);
    })
    .catch(catchHandler(dispatch, "car"));
};
export const GetCarReview =
  (carId, pageId = 0) =>
  async (dispatch) => {
    dispatchLoading(dispatch, "car", true);
    axios
      .get(carUrl + "/review", {
        params: { carId, pageId },
        withCredentials: true,
      })
      .then((result) => {
        if (result?.data?.success) {
          dispatch({
            type: "CAR_REVIEW_SET",
            payload: { name: carId, value: result?.data?.data },
          });
          dispatchError(dispatch, "car", undefined);
        } else elseHandler(dispatch, "car", result?.data);
        dispatchLoading(dispatch, "car", false);
      })
      .catch(catchHandler(dispatch, "car"));
  };
